<template>
    <div class="merged-page">
        <AppBreadCrumb :paths="[{ title: $t('message.tags') }]" :select="true">
            <a-button class="actionButtonBreadcrumb" @click="showModalView">
                <md-icon>add</md-icon>
                {{ $t("message.addTag") }}
            </a-button>
            <!--            <TagDialog />-->
        </AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex w-100">
            <div class="side-menubar-wrapper" style="width: 15%">
                <ContentsMenu />
            </div>
            <div id="tags">
                <div style="width: 99%">
                    <a-table
                        key="tag_key"
                        class="custom-table2"
                        :columns="cols()"
                        :dataSource="tags.data"
                        :loading="loading"
                        :pagination="false"
                        rowKey="_id"
                        :locale="{
                            emptyText: $t('message.noData'),
                        }"
                    >
                        <div slot="actionsSlot" slot-scope="data, item">
                            <div class="d-flex w-100 justify-content-start">
                                <a-button class="actionButton d-flex align-items-center" @click="edit(item)">
                                    <span style="margin-right: 16px; display: block">{{ $t("message.edit") }}</span>
                                    <ActionEdit />
                                </a-button>
                                <a-button class="actionButton d-flex align-items-center" @click="remove(item._id)">
                                    <span style="margin-right: 16px; display: block">{{
                                        $t("message.deleteField")
                                    }}</span>
                                    <ActionDelete />
                                </a-button>
                            </div>
                        </div>
                        <div slot="colorSlot" slot-scope="data, item">
                            <div
                                :style="{ backgroundColor: item.color || '#fff' }"
                                style="
                                    width: 24px;
                                    height: 24px;
                                    border-radius: 4px;
                                    box-shadow: rgb(97 97 97 / 28%) 0px 0px 8px 3px;
                                "
                            />
                        </div>
                    </a-table>
                    <Modal2
                        v-if="isModalShow"
                        id="tags-form"
                        :title="editMode ? $t('message.updateTag') : $t('message.addTag')"
                        :show-footer="false"
                        @cancel="hideModal"
                        rowKey="_id"
                    >
                        <a-form class="d-flex flex-column justify-content-center" @submit.prevent="duplicateControl">
                            <a-row class="mb-3">
                                <a-col>
                                    <a-form-item :label="$t('message.tagName')">
                                        <a-input v-model="form.name" :placeholder="$t('message.tagName')" />
                                    </a-form-item>
                                    <a-form-item :label="$t('message.tagDescription')">
                                        <a-textarea
                                            v-model="form.description"
                                            :placeholder="$t('message.tagDescription')"
                                        />
                                    </a-form-item>

                                    <a-form-item :label="$t('message.tagColor')">
                                        <a-input type="color" v-model="form.color" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col id="buttons">
                                    <a-button @click="hideModal">
                                        {{ $t("message.cancel") }}
                                    </a-button>
                                    <a-button
                                        :disabled="loading"
                                        type="submit"
                                        variant="primary"
                                        @click="duplicateControl"
                                        class="btn-primary"
                                    >
                                        <template v-if="!loading">
                                            <span v-if="!editMode">
                                                {{ $t("message.save") }}
                                            </span>
                                            <span v-else>
                                                {{ $t("message.update") }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            <font-awesome-icon icon="spinner" spin />
                                        </template>
                                    </a-button>
                                </a-col>
                            </a-row>
                        </a-form>
                    </Modal2>

                    <ChatBar v-if="!isAdmin" :visible="false" />
                </div>
            </div>
            <ChatBar v-if="!isAdmin" :visible="false" />
        </div>
    </div>
</template>

<script>
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import ChatBar from "../../components/ChatBar";
import { mapActions, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ActionEdit from "../../components/svg/ActionEdit";
import ActionDelete from "../../components/svg/ActionDelete";
import _ from "lodash";
import request from "../../utils/request";
import TagDialog from "../../components/TagDialog";
import Contents from "./Contents";
import ContentsMenu from "./ContentsMenu";
import { sendSocketMessage } from "../../utils/socketStream";
import Modal2 from "../../components/common/Modal2.vue";

library.add(faSpinner);
export default {
    name: "Tags",
    components: {
        Contents,
        TagDialog,
        AppBreadCrumb,
        ChatBar,
        ActionEdit,
        ActionDelete,
        ContentsMenu,
        Modal2,
    },
    computed: {
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
            tags: (state) => state.tag.tags,
            site: (state) => state.site.site,
        }),
    },
    data() {
        return {
            loading: false,
            editMode: false,
            editId: null,
            tagInitialState: Object.freeze({
                name: "",
                description: "",
                color: "#ffffff",
            }),
            form: {
                name: "",
                description: "",
                color: "#ffffff",
            },
            cols: () => [
                { dataIndex: "name", title: this.$t("message.tag_name_indicator") },
                { dataIndex: "description", title: this.$t("message.description") },
                {
                    dataIndex: "color",
                    title: this.$t("message.color"),
                    scopedSlots: { customRender: "colorSlot" },
                    width: "5%",
                },
                { title: this.$t("message.transactions"), scopedSlots: { customRender: "actionsSlot" }, width: "15%" },
            ],
            isModalShow: false,
            queryAction: this.$route.query.action,
        };
    },
    methods: {
        ...mapActions({
            getTags: "tag/getTags",
            updateTag: "tag/updateTag",
            deleteTag: "tag/deleteTag",
            createTag: "tag/createTag",
        }),
        showModalView() {
            this.editMode = false;
            this.isModalShow = true;
        },
        showModal() {
            this.isModalShow = true;
        },
        hideModal() {
            this.isModalShow = false;
            this.form.name = "";
            this.form.description = "";
            this.form.color = "#ffffff";
        },
        reset() {
            /*this.$bvModal.hide("tags-form");*/
            this.hideModal();
            this.form = _.clone(this.tagInitialState);
        },
        duplicateControl() {
            const isThereSameTag = this.tags.data.find(
                (tag) => tag.name.toLowerCase() === this.form.name.toLowerCase()
            );
            const duplicateId = isThereSameTag ? isThereSameTag._id : null;
            const isThisSameTag = duplicateId === this.editId;
            /*if (this.editMode && !isThisSameTag ){
                this.$toasted.error(this.$t("chatbotv2.sameTag"), {
                    duration: 3000,
                    position: "bottom-center",
                });
                return;
            }else if(isThereSameTag && !this.editMode){
                this.$toasted.error(this.$t("chatbotv2.sameTag2"), {
                    duration: 3000,
                    position: "bottom-center",
                });
                return;

            }else{
                this.handleSave();
            }*/
            if (!isThisSameTag && duplicateId !== null) {
                this.$toasted.error(this.$t("message.sameTag"), {
                    duration: 3000,
                    position: "bottom-center",
                });
                return;
            } else {
                this.handleSave();
            }
        },
        handleSave() {
            this.loading = true;
            try {
                if (!this.editMode && this.form.name) {
                    const result = this.createTag(this.form);
                    result.then(() => {
                        this.updateNewTags();
                    });
                } else {
                    const result = this.updateTag(this.form);
                    result.then(() => {
                        this.updateNewTags();
                    });
                }
                this.reset();
            } catch (e) {}
            this.loading = false;
        },

        get() {
            try {
                this.getTags().then(() => {
                    if (this.queryAction == "create") this.isModalShow = true;
                });
                log.debug("this.tags.data", this.tags.data);
            } catch (e) {}
        },
        updateNewTags() {
            const socketMessageId = "user tags-updated";
            sendSocketMessage(socketMessageId, {
                siteId: this.site._id,
            });
        },
        remove(id) {
            this.$dialog
                .confirm(this.$t("message.deleteConfirm", { object: this.$t("message.tags") }), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    const result = this.deleteTag(id);
                    result.then(() => {
                        this.updateNewTags();
                    });
                });
        },
        edit(item) {
            this.form = _.clone(item);
            this.editMode = true;
            this.editId = item._id;
            /*this.$bvModal.show("tags-form");*/
            this.showModal();
        },
    },
    mounted() {
        this.get();
    },
    /*watch: {
        editMode(val) {
            console.log("Edit Mode : ", val);
        },
    },*/
};
</script>

<style lang="scss" scoped>
.custom-tabs .nav.nav-tabs {
    position: absolute;
    top: 49px;
    left: 30px;
    right: 30px;
    z-index: 123;
}

.merged-page {
    position: relative;

    .custom-breadcrumb {
        margin-bottom: 1px;
    }
}
</style>
<style lang="scss">
#tags {
    min-height: 90vh;
    width: 85%;
    background: #eef0f8;
}

.ant-table-column-title {
    color: #181c32;
    font-size: 13px;
    font-weight: 300;
    font-family: Poppins;
    white-space: nowrap;
    padding-left: 10px;
}

#buttons {
    display: flex;
    justify-content: flex-end;
    gap: 7px;
}

#tags-form {
    .ant-form-item label {
        font-weight: 700;
        font-size: 15px;
        color: #9ba2b6;
        line-height: 0px;
    }

    .ant-form legend {
        color: rgba(0, 0, 0, 0.45);
        border-bottom: none;
    }

    .ant-form-item-label {
        line-height: 28px;
    }

    .ant-form-item-label > label::after {
        content: "";
    }

    .ant-radio-wrapper {
        color: #4b5361 !important;
        font-weight: 400 !important;
        height: 14px;
        width: 14px;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
    }

    .ant-radio-wrapper:last-child {
        margin-left: 50px;
    }

    .ant-radio-wrapper span {
        font-size: 14px;
    }

    .modal-body button {
        width: 160px;
    }

    .btn-primary {
        background-color: #03a9f4;
        border-color: #03a9f4;
        color: #fff;
    }

    .btn-primary:hover {
        background-color: #028fce;
        border-color: #028fce;
        color: #fff;
    }

    .btn-secondary {
        background-color: #6c757d;
        border-color: #6c757d;
        color: #fff;
    }

    .btn-secondary:hover {
        background-color: #596267;
        border-color: #596267;
        color: #fff;
    }
}
</style>
